/* eslint-disable max-len */
import React from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { VehicleDetail } from '@1po/1po-bff-fe-spec/generated/common/vehicle/VehicleDetail';
import { ROUTER_CATALOG_MAINTENANCE_PLAN } from 'app/AppRouter';
import { getCatalogSourceUrl } from 'domains/catalog/Catalog.utils';
import { fetchIAMAvailableModulesRequestSaga, getIAMAvailableModules } from 'domains/catalog/CatalogIam.store';
import { getUserRights } from 'domains/user';
import {
  getHasAccessToTechnicalLinks,
  notAuthorizedTab,
  notAvailableTab,
  notLoadedTab,
} from 'pages/CatalogPage/common/CatalogBanner/TabCommon';
import MaintenancePlan from 'pages/CatalogPage/IAM/MaintenancePlan';
import { Container, Text } from 'UI';
import { getCondArrayItem, getData, hasUserR3WithSubscriptionL234 } from 'utils';

export const TabMaintenanceIam = ({
  renderVehicleTabContent,
  setCatalogShowMenu,
  vehicleDetail,
  isIam,
  includeVehicleTabContent = true,
}: {
  renderVehicleTabContent: JSX.Element;
  setCatalogShowMenu: (v: boolean) => void;
  vehicleDetail: VehicleDetail;
  isIam: boolean;
  includeVehicleTabContent?: boolean;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const userRights = getData(useSelector(getUserRights));

  const availableDataModule = getData(useSelector(getIAMAvailableModules));
  const getDataAvailableMaintenance = () =>
    availableDataModule?.availableData?.find((d) => d.name === 'servicePlan')?.dataAvailable;
  const available = getDataAvailableMaintenance();
  const label = t('catalog.parts.banner.maintenance_plan.title', 'Maintenance plan');
  const key = 4;
  const link = `${getCatalogSourceUrl(vehicleDetail.catalogSource)}/${
    vehicleDetail.vehicleKey
  }${ROUTER_CATALOG_MAINTENANCE_PLAN}`;

  const handleTab = () => {
    if (!availableDataModule && hasUserR3WithSubscriptionL234(userRights)) {
      //R3 or R3_MOTRIO with enough rights must trigger loading by clicking on tab
      dispatch(fetchIAMAvailableModulesRequestSaga());
      return notLoadedTab({ key, label, link, dataCy: 'tab-maintenance-plan-not-loaded' });
    }
    if (!available) {
      return notAvailableTab({ key, label, dataCy: 'tab-maintenance-plan-iam-not-available', link });
    }
    if (
      !getHasAccessToTechnicalLinks({
        isIam,
        versionCode: vehicleDetail.iamVehicle?.versionCode,
        userRights,
      })
    ) {
      return notAuthorizedTab({ key, label, dataCy: 'tab-maintenance-plan-not-authorized' });
    }

    return {
      key,
      link,
      label: (
        <Text type={'lead_text_white'} noWrap>
          {label}
        </Text>
      ),
      component: (
        <>
          {includeVehicleTabContent && renderVehicleTabContent}
          <Container>
            <MaintenancePlan setCatalogShowMenu={setCatalogShowMenu} />
          </Container>
        </>
      ),
      dataCy: 'tab-maintenance-plan',
    };
  };
  return getCondArrayItem(isIam && handleTab());
};
